module.exports = __webpack_public_path__ + "assets/color-palette.00acf80a.svg";